import React from "react";
import { useTranslation } from "react-i18next";
import { CardContainer } from "routes/createContent/components/styles";
import { GET_TEMPLATES } from "./__mocks__";
import { LibraryItem } from "../../components/LibraryItem/LibraryItem";
import { useHistory } from "react-router-dom";
import { Area } from "types";
import { JointImage } from "shared/JointImage";

export const Templates: React.VFC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div>
      <h1>Templates</h1>
      <p>List of templates will be displayed here.</p>

      <CardContainer>
        {GET_TEMPLATES?.map(template => {
          const name = template.key
            ? // @ts-ignore
              t(`usercourse.templates.standardized.name.${template.key}`)
            : template.name || String(template.id);

          return (
            <LibraryItem
              key={template.id}
              author={
                template.standardized
                  ? undefined
                  : {
                      // TODO: fix avatar
                      avatar: <div>AVATAR</div>,
                      name: "Author name",
                    }
              }
              checked={false}
              id={template.id}
              image={template.key ? <JointImage id={template.key} /> : undefined}
              title={name as string}
              onClick={() => {
                history.push(`${Area.CreateContent_Templates}/${template.id}`);
              }}
              onDelete={
                () => {
                  console.log("Delete template:", template.id);
                }
                // template.standardized
                //   ? undefined
                //   : () => {
                //       setSelectedTemplate(template.id);
                //       setShowDeleteConfirmationPopup(true);
                //     }
              }
            />
          );
        })}
      </CardContainer>
    </div>
  );
};
